import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Eye, EyeOff, LogIn } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import Logo from '../../components/Logo';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Por favor preencha todos os campos');
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      toast.success('Login efetuado com sucesso!');
      navigate('/admin');
    } catch (error) {
      const detail = error.response?.data?.detail;
      let message = 'Erro ao efetuar login';
      if (typeof detail === 'string') {
        message = detail;
      } else if (Array.isArray(detail)) {
        message = detail.map(e => e.msg || JSON.stringify(e)).join(' ');
      }
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#090A0F] flex items-center justify-center px-6">
      <div className="w-full max-w-md animate-fade-in">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="flex flex-col items-center mb-4">
            <Logo size="large" />
          </div>
          <p className="text-zinc-500 mt-4">Área de Administração</p>
        </div>

        {/* Login Form */}
        <div className="bg-[#12141D] border border-zinc-800 p-8" data-testid="admin-login-form">
          <h2 className="text-xl font-medium text-white mb-6">Iniciar Sessão</h2>
          
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-zinc-400 text-sm mb-2 block">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@icardetail.pt"
                className="bg-[#090A0F] border-zinc-800 text-white placeholder:text-zinc-600 focus:border-red-500 h-12"
                data-testid="admin-email-input"
              />
            </div>
            
            <div>
              <label className="text-zinc-400 text-sm mb-2 block">Password</label>
              <div className="relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-[#090A0F] border-zinc-800 text-white placeholder:text-zinc-600 focus:border-red-500 h-12 pr-12"
                  data-testid="admin-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300"
                  data-testid="toggle-password-btn"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black font-semibold h-12 hover:bg-zinc-200 transition-colors rounded-none"
              data-testid="admin-login-btn"
            >
              <LogIn size={18} className="mr-2" />
              {loading ? 'A entrar...' : 'Entrar'}
            </Button>
          </form>
        </div>

        <p className="text-center text-zinc-600 text-sm mt-6">
          <a href="/" className="text-zinc-400 hover:text-white transition-colors">
            ← Voltar ao site
          </a>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
